// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3sj8L","author":"Table_author__2xxY1","authorImage":"Table_authorImage__wjr4p","unreadRow":"Table_unreadRow__1o2KI"};